var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "multidamage-list view" },
    [
      _c(
        "div",
        { staticClass: "view_top" },
        [
          _c("ma-navbar-category", {
            attrs: {
              titleNavbar: _vm.titleNavBar,
              qaName: "go-to-damagedParts-btn",
              handleClickBack: _vm.handleClickPrevRoute,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "view_content" },
        _vm._l(_vm.multidamagePieces, function (damagedPieceType, index) {
          return _c(
            "div",
            { key: damagedPieceType.id, staticClass: "container-piece" },
            _vm._l(damagedPieceType.pieces, function (damagedPiece) {
              return _c(
                "div",
                { key: damagedPiece.id, staticClass: "damage-piece" },
                [
                  _c("maDamagedPiece", {
                    staticClass: "piece-container",
                    attrs: {
                      damagedLiteral: damagedPieceType.literal,
                      damagedKey: damagedPieceType.damageKey,
                      damagedPiece: damagedPiece,
                      damagedSurface: damagedPiece.pieceSurface,
                      isPhotoclaimFlow: _vm.isPhotoclaimFlow,
                      photosTaken: damagedPiece.photosTaken,
                      expanded: index === 0 || _vm.isExpanded,
                    },
                    on: {
                      surfaceChanged: function ($event) {
                        return _vm.handleOnSurfaceChange(
                          damagedPieceType.damageKey,
                          damagedPiece.pieceId,
                          $event
                        )
                      },
                      deleteDamagedPart: function ($event) {
                        return _vm.handleOnDeleteDamagedPart(
                          damagedPieceType.damageKey,
                          damagedPiece.pieceId,
                          $event
                        )
                      },
                      deleteDamage: function ($event) {
                        return _vm.handleOnDeleteDamage(
                          damagedPieceType.damageKey,
                          damagedPiece.pieceId,
                          $event
                        )
                      },
                      editDamage: function ($event) {
                        return _vm.handleOnEditDamage(
                          damagedPieceType.damageKey,
                          damagedPiece.pieceSurface,
                          damagedPiece.pieceId,
                          $event
                        )
                      },
                      openModal: function ($event) {
                        return _vm.handleOnShowModal(
                          damagedPieceType.damageKey,
                          damagedPiece.pieceSurface,
                          damagedPiece.pieceId,
                          $event
                        )
                      },
                      openPhotoclaimModal: function ($event) {
                        return _vm.handlePhotoclaimModal(
                          damagedPieceType.literal,
                          damagedPieceType.damageKey,
                          damagedPiece.pieceSurface,
                          damagedPiece.pieceId,
                          $event
                        )
                      },
                      openSurfaceModal: function ($event) {
                        return _vm.handleSurfaceModal(
                          true,
                          damagedPieceType.damageKey,
                          damagedPiece.pieceId
                        )
                      },
                      confirmPhotoclaimDamages: function ($event) {
                        return _vm.handleConfirmPhotoclaimDamages(
                          damagedPieceType.damageKey,
                          ...arguments
                        )
                      },
                      "add:photoclaimDamage": _vm.handleOnAddPhotoclaimDamage,
                      "edit:photoclaimDamage": _vm.handleOnEditPhotoclaimDamage,
                      "delete:photoclaimDamage": function ($event) {
                        return _vm.handleOnDeletePhotoclaimDamage(
                          damagedPieceType.damageKey,
                          ...arguments
                        )
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          )
        }),
        0
      ),
      !_vm.isPhotoclaimFlow
        ? _c(
            "div",
            { staticClass: "view_actions" },
            [
              _c("maButton", {
                attrs: {
                  handleButtonClick: _vm.handleOnAddMultidamage,
                  title: _vm.$t("multidamageList.btnAddAllDamages"),
                  shouldBeDisabled: _vm.btnAddAllDamagesIsDisabled,
                  btnType: _vm.getBtnType,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("maMultidamageForm", {
        ref: "multidamageForm",
        staticClass: "save-button",
        attrs: {
          damageReport: _vm.selectedDamageReport,
          pieceId: _vm.selectedPieceId,
          damagedPart: _vm.selectedDamagedPart,
          pieceSurface: _vm.selectedPieceSurface,
          editIndex: _vm.selectedDamageIndex,
        },
        on: { "form:partDamageAdded": _vm.handleOnPartDamageAdded },
      }),
      _c("maMultidamagePcForm", {
        ref: "multidamagePcForm",
        staticClass: "save-button",
        attrs: {
          damageReport: _vm.selectedDamageReport,
          pieceId: _vm.selectedPieceId,
          damagedPart: _vm.selectedDamagedPart,
          pieceSurface: _vm.selectedPieceSurface,
          editIndex: _vm.selectedDamageIndex,
        },
        on: { "form:partDamageAdded": _vm.handleOnPartDamageAddedFromPc },
      }),
      _c("maPhotoclaimForm", {
        ref: "photoclaimForm",
        staticClass: "save-button",
        attrs: {
          damageReport: _vm.selectedDamageReport,
          pieceId: _vm.selectedPieceId,
          allDamagedParts: _vm.selectedAllDamagedParts,
          pieceSurface: _vm.selectedPieceSurface,
        },
        on: { "form:allDamagedPartsAdded": _vm.handleOnAllPartsDamageAdded },
      }),
      _c("maCalculateSurfaceModal", {
        attrs: { "pieceId:": "", modalIsOpen: _vm.surfaceModalIsOpen },
        on: {
          closeSurfaceModal: function ($event) {
            return _vm.handleSurfaceModal(false)
          },
          calculateSurface: function ($event) {
            return _vm.handleCalculateSurface($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }